import { Reducer } from 'redux'
import {
  ChannelPartnerPrivateOfferActionTypes,
  ChannelPartnerPrivateOffersAction,
  ChannelPartnerPrivateOffersState,
  initialChannelPartnerPrivateOffersState,
} from './types'

export * from './types'

export const reducer: Reducer<
  ChannelPartnerPrivateOffersState,
  ChannelPartnerPrivateOffersAction
> = (state = initialChannelPartnerPrivateOffersState, action) => {
  switch (action.type) {
    case ChannelPartnerPrivateOfferActionTypes.SET_CHANNEL_PARTNER_PRIVATE_OFFERS_DATA: {
      return {
        ...state,
        awsCppos: state.awsCppos.concat(action.payload.awsCppos),
        count: action.payload.count,
        pageNumber: action.payload.pageNumber,
        pageSize: action.payload.pageSize,
      }
    }
    case ChannelPartnerPrivateOfferActionTypes.SET_CREATE_CHANNEL_OFFERS_DATA: {
      return {
        ...state,
        channelPartnerPrivateOfferInCreation: {
          [action.payload.resellerAuthId]: {
            ...action.payload.channelOffer,
          },
        },
      }
    }
    case ChannelPartnerPrivateOfferActionTypes.SET_SINGLE_CHANNEL_OFFER_DATA: {
      return {
        ...state,
        currentChannelPartnerPrivateOffer: {
          [action.payload.resellerAuthId]: {
            ...action.payload.channelOffer,
          },
        },
      }
    }
    case ChannelPartnerPrivateOfferActionTypes.CLEAR_CHANNEL_OFFER_IN_CREATION: {
      return {
        ...state,
        channelPartnerPrivateOfferInCreation: {
          [action.payload]: {},
        },
      }
    }
    case ChannelPartnerPrivateOfferActionTypes.CLEAR_CHANNEL_OFFERS: {
      return {
        ...state,
        awsCppos: [],
        count: 0,
        pageNumber: 1,
        pageSize: 10,
      }
    }
    default:
      return state
  }
}
